import config from 'services/table/const';
import Action from './table.action';

let table = { ...config };

table.url = '/accounting/transaction';
table.columns = {
  Name: {
    title: 'Name',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.name}
          </div>
        </div>
      );
    },
  },

  debit: {
    title: 'Coa',
    sortable: false,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.items?.map((p) => (
              <small className='info fs-9'>{p?.type} - {p?.coa?.alias_name}</small>
            ))}
          </div>
        </div>
      );
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 50,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
